module.exports = __webpack_public_path__ + "static/media/CNBC_Logo_White.0965cf99.svg";